import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/landing/Hero";
import { PainIdentification } from "@/components/landing/PainIdentification";
import { ElephantInTheRoom } from "@/components/landing/ElephantInTheRoom";
import { RealCost } from "@/components/landing/RealCost";
import { AuthoritySection } from "@/components/landing/AuthoritySection";
import { FourRsFramework } from "@/components/landing/FourRsFramework";
import { ProductVisualization } from "@/components/landing/ProductVisualization";
import { MidCTA } from "@/components/landing/MidCTA";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { CertificationPathway } from "@/components/landing/CertificationPathway";
import { Certifications } from "@/components/landing/Certifications";
import { LandingPricing } from "@/components/landing/LandingPricing";
import { ChurchTraining } from "@/components/landing/ChurchTraining";
import { PastorsSection } from "@/components/landing/PastorsSection";
import { SafeSoulStandard } from "@/components/landing/SafeSoulStandard";
import { FAQ } from "@/components/landing/FAQ";
import { SEOHead } from "@/components/SEOHead";
import { TrustStatement } from "@/components/landing/TrustStatement";

const Index = () => {
  return (
    <>
      <SEOHead />
      <div className="min-h-screen bg-background">
        <Navbar />
        <main>
          {/* 1. Hero — Immersive movement statement */}
          <Hero />

          {/* Pain Identification — hidden */}

          {/* 3. Elephant in the Room — Confront the problem */}
          <ElephantInTheRoom />

          {/* Real Cost of Unsafe Churches */}
          <RealCost />

          {/* Trust Statement — conversion bridge */}
          <TrustStatement />

          {/* Authority — hidden */}

          {/* Four R's Framework — hidden */}

          {/* 6. Product Visualization — Platform tools + mockup */}
          <ProductVisualization />

          {/* Mid CTA */}
          <MidCTA
            headline="Join the Movement"
            subtext="This is your next step toward healing and reform."
            variant="dark"
          />

          {/* 7. Testimonials */}
          <TestimonialsSection />

          {/* 8. Certification Pathway — Join → Learn → Heal → Certify → Lead */}
          <CertificationPathway />

          {/* 9. Certifications detail */}
          <Certifications />

          {/* 10. Pricing / Offer */}
          <LandingPricing />

          {/* 11. Church Training */}
          <ChurchTraining />

          {/* Registry CTA */}
          <MidCTA
            headline="Is Your Church Certified?"
            subtext="Search churches certified under the Soul Safe Standard™ for accountability, transparency, and survivor-conscious care."
            variant="dark"
            primaryButtonLabel="Find a Certified Safe Church"
            primaryButtonLink="/safe-soul-registry"
            showSecondaryButton={false}
          />

          {/* 14. FAQ */}
          <FAQ />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
